<template>
  <div class="border rounded p-4">
    <div class="title font-weight-bold h6 mb-3">
      Mapa
    </div>
    <div class="mt-4">
      <z-map
        id="service-detail-map"
        :destinations="destinations"
        :route="route"
        :calculate-route="calculateRoute"
        :center="center"
      />
    </div>
  </div>
</template>

<script>
import ZMap from "@zubut/common/src/components/ZMap";

export default {
  name: "SerivceDetailTabMap",

  components: { ZMap },

  props: {
    service: {
      type: Object,
      required: true
    }
  },

  computed: {
    destinations() {
      return this.service.destinations;
    },

    center() {
      if (this.destinations.length > 0) {
        return this.destinations[0].position;
      } else {
        return { lat: 20.6737777, lng: -103.4054536 };
      }
    },

    route() {
      if (this.service && this.service.route && this.service.route.latLng) {
        return this.service.route.latLng;
      }
      return [];
    },

    calculateRoute() {
      return this.route.length === 0;
    }
  }
};
</script>

<style lang="scss" scoped>
#service-detail-map {
  height: 500px !important;
  width: 100%;
  border-radius: 10px;
}
</style>
